import { render } from "./App.vue?vue&type=template&id=68f1875b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=68f1875b&lang=css"

import exportComponent from "C:\\Users\\Kos\\Downloads\\filemgr.mREaF3.2026-05-15_16_14_46\\vxadoor.pro\\hubuntu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__